import { startCase } from 'lodash'
import { CheckCircle2, XCircle } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const JourneyToFirstImpactCard = ({ journeyProgressPercentage, journeyStepsKeys, profile }) => {
  return (
    <Card className='w-auto mb-5'>
      <CardHeader>
        <CardTitle className='text-xl'>Journey to First Impact</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center mb-4">
          {(() => {
            const hue = (journeyProgressPercentage / 100) * 120; // 0 (red) to 120 (green)
            const barColor = `hsl(${hue.toFixed(0)}, 70%, 50%)`;
            return (
              <div className="w-[90%] bg-gray-200 rounded-full h-3.5 dark:bg-gray-700 mr-3">
                <div
                  className="h-3.5 rounded-full"
                  style={{ width: `${journeyProgressPercentage.toFixed(0)}%`, backgroundColor: barColor }}
                ></div>
              </div>
            );
          })()}
          <span className="text-lg font-medium text-gray-700 dark:text-gray-300">{`${journeyProgressPercentage.toFixed(0)}%`}</span>
        </div>
        <dl className='divide-y divide-gray-100 dark:divide-gray-700'>
          {journeyStepsKeys.map(key => {
            const label = key === 'seriesCreated' ? 'Pathway Created' :
              key === 'createdAndAssignedSeries' ? 'Pathway Assigned' :
                key === 'enrolledStudents' ? 'Enrolled Students' :
                  key === 'signedUp' ? 'Signed Up' :
                    startCase(key);
            let isCompleted;
            if (key === 'signedUp') {
              isCompleted = profile.educatorOnboardingCompleted;
            } else {
              isCompleted = profile.adminActivationMilestones && profile.adminActivationMilestones[key];
            }
            return (
              <div key={key} className='py-3 sm:grid sm:grid-cols-3 sm:gap-4'>
                <dt className='font-medium text-gray-900 dark:text-gray-100'>{label}</dt>
                <dd className='mt-1 leading-6 text-gray-700 dark:text-gray-300 sm:col-span-2 sm:mt-0 flex items-center'>
                  {isCompleted ?
                    <CheckCircle2 className="h-5 w-5 text-green-500 mr-2" /> :
                    <XCircle className="h-5 w-5 text-red-500 mr-2" />}
                  {isCompleted ? 'Completed' : 'Not Completed'}
                </dd>
              </div>
            );
          })}
        </dl>
      </CardContent>
    </Card>
  );
}

export default JourneyToFirstImpactCard; 
